import React from 'react';
import { useSelector } from 'react-redux';
import NvTooltip from 'shared/components/nv-tooltip';
import ClickableContainer from 'components/clickable-container';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import { AngularServicesContext } from 'react-app';
import { NavigationHeaderOrigin } from './navigation-header';

const NavigationCenterElement = ({
  origin,
  scrolledHeader,
  catalogId,
}) => {
  const currentJourney = useSelector((state) => state.models.courses[catalogId]);
  const {
    $state,
  } = React.useContext(AngularServicesContext);

  const handleHomeClick = () => {
    $state.go('learning-journey-home', { catalogId });
  };

  switch (origin) {
    case NavigationHeaderOrigin.USER_MANAGEMENT:
      return (
        <NvTooltip placement='auto' text={t.DASHBOARD.BACK_TO_JOURNEY_HOME_TOOLTIP()}>
          <ClickableContainer
            className='home-button hoverable'
            onClick={handleHomeClick}
            aria-label={t.DASHBOARD.BACK_TO_JOURNEY_HOME_TOOLTIP()}
          >
            <div className={`course-title-small font-weight-bolder d-flex align-items-center title ellipsis${scrolledHeader ? ' scrolled' : ''}`}>
              <NvIcon icon='path' size='small' />
              {currentJourney?.name ?? ''}
            </div>
          </ClickableContainer>
        </NvTooltip>
      );
    case NavigationHeaderOrigin.HOME:
    default:
      return (
        <div className={`course-title-regular title ellipsis d-flex align-items-center${scrolledHeader ? ' scrolled' : ''}`}>
          <NvIcon className='journey-icon' icon='path' size='small' />
          {currentJourney?.name ?? ''}
        </div>
      );
  }
};

export default NavigationCenterElement;
